export enum Links {
  FEATURES_PAYMENTS = '/features/payments',
  FEATURES_MARKETPLACE = '/features/marketplace',
  FEATURES_REQUESTS = '/features/requests',
  FEATURES_SUGGESTIONS = '/features/suggestions',
  FEATURES_APPRECIATIONS = '/features/appreciations',
  FEATURES_PROPOSALS = '/features/proposals',
  FEATURES_ALERTS = '/features/alerts',
  FEATURES_EVENTS = '/features/events',
  FEATURES_FACEBOOK = '/features/facebook',
  FEATURES_FACEBOOK_GROUPS = '/features/facebook/groups',
  FEATURES_DIGITAL_ID = '/features/digital-id',
  CITIES_BENEFITS = '/cities/benefits',
  CITIES_CITYCARE = '/cities/citycare',
  CITIES_SETUP = '/cities/setup',
  CITIES_PRICING = '/cities/pricing',
  CITIES_COACHING = '/cities/coaching',
  LOGIN = '/login',
  ABOUT = '/about',
  BLOG = '/blog',
  CARRERS = '/careers',
  LEGAL = '/legal',
  LEGAL_EULA = '/legal/eula',
  LEGAL_PRIVACY = '/legal/privacy',
  LEGAL_ACCEPTABLE_USE = '/legal/acceptable_use',
  LEGAL_PRIVACY_MOBILE = '/legal/privacy_mobile',
  LEGAL_IDEAS_GUIDELINES = '/legal/ideas_guidelines',
  LEGAL_WEBSITE = '/legal/website',
  LEGAL_MSA = '/legal/msa',
  LEGAL_SLA = '/legal/sla',
  LEGAL_ITSEC = '/legal/itsec',
  LEGAL_TERMS_OF_SERVICE = '/legal/terms_of_service',
  LEGAL_DATA_PROCESSING = '/legal/data_processing',
  LEGAL_CLOUD_HOSTING = '/legal/cloud_hosting',
  LEGAL_FACEBOOK_COMMUNITY_PROGRAM = '/legal/facebook_community_program',
  HELP = '/help',
  IDEIAS = '/ideas',
  CONNECTORS = '/connectors',
}
